import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logoUrl from "@/assets/logo.svg";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/card";

export function EntryPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-1">
            <img src={logoUrl} alt="RaiSE" className="h-8 invert dark:invert-0" />
          </div>
          <CardDescription>{t("entry.subtitle")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button variant="outline" className="w-full h-auto py-4 flex-col items-start gap-1" asChild>
            <Link to="/signup">
              <span className="font-medium">{t("entry.createOrg")}</span>
              <span className="text-xs text-muted-foreground">{t("entry.createOrgDescription")}</span>
            </Link>
          </Button>
          <Button variant="outline" className="w-full h-auto py-4 flex-col items-start gap-1" asChild>
            <Link to="/login?flow=join">
              <span className="font-medium">{t("entry.joinTeam")}</span>
              <span className="text-xs text-muted-foreground">{t("entry.joinTeamDescription")}</span>
            </Link>
          </Button>
        </CardContent>
        <div className="pb-6 text-center text-sm text-muted-foreground">
          {t("entry.existingAccount")}{" "}
          <Link to="/login" className="text-foreground underline hover:no-underline">
            {t("entry.logIn")}
          </Link>
        </div>
      </Card>
    </div>
  );
}
